import styled from "styled-components";
const Container = styled.div`
  max-width: 1423px;
  margin: 0 auto;
  min-height: 676px;
`;
const DashBoardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto auto;
  grid-gap: min(30px, 2.85vw);
  position: relative;
  .pallet-image {
    position: absolute;
    right: 0;
    bottom: -8vw;
    width: min(375px, 26.6vw);
    height: auto;
  }
  @media (min-width: 1412px) {
    .pallet-image {
      bottom: -117px;
    }
  }
  @media (max-width: 766px) {
    display: block;
  }
  @media (max-width: 555px) {
    .pallet-image {
      min-width: 140px;
      bottom: -78px;
    }
  }
`;
const DashBoardHeading = styled.div`
  color: #0a5587;
  grid-area: 1 / 1 / 3 / 3;
  padding: 1vw 0 1.9vw 148px;
  max-width: 58vw;
  h3 {
    font-size: 2.3vw;
    margin-bottom: 0.7vw;
    font-family: "latoblack";
  }
  /* p {
    font-size: 1.5vw;
    margin: 0;
    line-height: 2.27vw;
    color: #676767;
  } */
  @media (min-width: 1412px) {
    max-width: 750px;

    h3 {
      font-size: 32px;
      margin-bottom: 10px;
    }
    p {
      font-size: 21px;
      margin: 0;
      line-height: 1.17;
    }
  }
  @media (max-width: 1250px) {
    padding: 1vw 0 1.9vw 99px;
  }
  @media (max-width: 766px) {
    padding: 15px;
    max-width: 100%;
    text-align: center;
    h3 {
      font-size: 24px;
      line-height: normal;
    }
    p {
      font-size: 14px;
      line-height: normal;
    }
  }
`;
const BuyPallets = styled.div`
  /* background-color: #074269; */
  color: #fff;
  height: min(253px, 18vw);
  display: flex;
  justify-content: center;
  align-items: flex-end;
  flex-direction: column;
  width: min(465px, 33vw);
  position: relative;
  z-index: 1;
  .text-wrapper {
    position:relative;
    /* margin-right: min(-125px, -9vw); */
    margin-bottom: min(35px, 2.5vw);

    > div {
      display: flex;
    }
  }
  .overlay{
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    z-index:1;
  }
  h3 {
    font-size: min(42px, 3vw);
    font-family: "latosemibold";
  }
  p {
    font-size: min(14px, 1vw);
    font-family: "latobold";
    margin-top: 4px;
  }
  .dropdown-wrapper {
    .dropdown-toggle {
      border-radius: 0 5px 5px 0;
    }
  }
  .type-ahead-search-input {
    height: min(37px, 2.83vw);
    .dropdown-item {
      font-size: 17px;
      line-height: 2.29;
      padding: 0 12px !important;
      border-top: 1px solid #87cdf1;
      color: #08446d;
      font-family: "latoregular" !important;
      position: relative;
      :first-child {
        border: none;
      }
      img.arrow-image {
        display: none;
      }
      :hover {
        font-weight: bold;
        background-color: #fff;
        color: #08446d;
        img.arrow-image {
          position: absolute;
          left: -43px;
          top: 5px;
          display: inline-flex;
        }
      }
    }
    .dropleft .dropdown-menu {
      padding: 0 9px 0 42px;
      border: 1px solid #87cdf1;
      border-radius: 5px;
      top: -1px !important;
      width: min(341px, 24vw);
      min-width: 254px;
      margin: 0;
      @media (max-width: 555px) {
        padding: 0 9px;
        min-width: 185px;
      }
    }
    .seacrh-icon {
      position: absolute;
      right: 0;
      max-width: 29px;
      margin: 0;
    }
    > div {
      height: 100%;
      input {
        height: 100%;
        border-color: transparent;
        border-radius: 5px 0 0 5px;
        border: none;
      }
    }
  }
  .triangle-wrapper {
    .buy-triangle {
      display: none;
    }
  }
  @media (min-width: 1412px) {
   
  }
  @media (max-width: 766px) {
    width: 227px;
    height: 137px;
    margin-left: 70px;
    .text-wrapper {
      margin: 0;
    }
    .overlay{
        margin: 0;
    }
    .triangle-wrapper {
      position: relative;
      display: flex !important;
      align-items: center;
      justify-content: flex-start;
      max-width: 100% !important;
      .buy-triangle {
        width: 0;
        height: 0;
        border: 0 solid transparent;
        border-top-width: 59px;
        border-bottom-width: 59px;
        border-left: 87px solid #074269;
        position: absolute;
        display: block;
        left: 145px;
        z-index: 0;
      }
    }
    h3 {
      font-size: 24px;
    }
    p {
      font-size: 10px;
    }
    .dropdown-toggle {
      border-radius: 0 5px 5px 0 !important;
      margin: 0 !important;
      color: #074269;
    }
    .type-ahead-search-input {
      height: 28px;
      width: 100% !important;
      max-width: 185px;
      > div input {
        border-radius: 5px 0 0 5px;
        font-size: 12px;
      }
    }
  }
  @media (max-width: 555px) {
    margin-left: 10px;
     .overlay{
        margin: 0;
    }
    .dropdown-item {
      font-size: 12px !important;
    }
  }
`;
const SellPallets = styled.div`
  .text-wrapper {
    margin-left: min(99px, -7vw);
    margin-left: min(99px, 0vw);
    margin-bottom: min(35px, 2.5vw);
    > div {
      display: flex;
    }
  }
  .overlay{
    position: absolute;
    top:0;
    bottom:0;
    left:0;
    right:0;
    margin-left: min(99px,-7vw);
    z-index:1;
  }
  position: relative;
  color: #fff;
  height: min(253px, 18vw);
  width: min(465px, 33vw);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  h3 {
    font-size: min(42px, 3vw);
    font-family: "latosemibold";
  }
  p {
    font-size: min(14px, 1vw);
    font-family: "latobold";
    margin-top: 4px;
    color: #053d62;
  }
  .dropdown-wrapper {
    border-radius: 0;
    .dropdown-toggle {
      border-radius: 0 5px 5px 0;
    }
  }
  .type-ahead-search-input {
    height: min(37px, 2.83vw);

    .dropdown-item {
      font-size: 17px;
      line-height: 2.29;
      padding: 0 12px !important;
      border-top: 1px solid #87cdf1;
      color: #08446d;
      font-family: "latoregular" !important;
      position: relative;
      :first-child {
        border: none;
      }
      img.arrow-image {
        display: none;
      }
      :hover {
        font-weight: bold;
        background-color: #fff;
        color: #08446d;
        img.arrow-image {
          position: absolute;
          left: -43px;
          top: 5px;
          display: inline-flex;
        }
      }
    }
    .dropleft .dropdown-menu {
      padding: 0 9px 0 42px;
      border: 1px solid #87cdf1;
      border-radius: 5px;
      top: -1px !important;
      width: min(341px, 24vw);
      min-width: 254px;
      margin: 0;
      @media (max-width: 555px) {
        padding: 0 9px;
        min-width: 185px;
      }
    }
    .seacrh-icon {
      position: absolute;
      right: 0;
      max-width: 29px;
      margin: 0;
    }
    > div {
      height: 100%;
      input {
        height: 100%;
        border-color: transparent;
        border-radius: 5px 0 0 5px;
        border: none;
      }
    }
  }
  .triangle-wrapper {
    .sell-triangle {
      display: none;
    }
  }
  @media (max-width: 766px) {
    width: 227px;
    height: 137px;
    margin-right: 70px;
    .overlay{
        margin: 0;
    }
    .sell-triangle {
      display: none;
    }
    .text-wrapper {
      margin: 0;
    }
    .triangle-wrapper {
      position: relative;
      display: flex !important;
      align-items: center;

      max-width: 100% !important;
    }
    h3 {
      font-size: 24px;
    }
    p {
      font-size: 10px;
    }

    .dropdown-toggle {
      border-radius: 0 5px 5px 0 !important;
      margin: 0 !important;
      color: #4cc1fe;
    }
    .type-ahead-search-input {
      height: 28px;
      width: 100% !important;
      max-width: 185px;
      > div input {
        border-radius: 5px 0 0 5px;
        font-size: 12px;
      }
    }
    .dropdown-wrapper {
      /* max-width: 100%; */
      height: 28px;
      width: auto !important;
      max-width: auto;
      border-radius: 0;
      border: none;
    }
  }
  @media (max-width: 555px) {
    margin-right: 10px;

    .dropdown-item {
      font-size: 12px !important;
    }
  }
`;
const SellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  grid-area: 1 / 2 / 4 / 4;
  position: relative;
  margin-top: min(90px, 6.4vw);
  .dashboard-left-arrow {
    position: absolute;
    right: 0;
    z-index: 0;
    width: min(783px, 55.5vw);
    display: block;
  }
  .dashboard-left-arrow-mobile {
    display: none;
  }
  .sell-triangle {
    width: 0;
    height: 0;
    border: 0 solid transparent;
    border-top-width: 15.26vw;
    border-bottom-width: 15.26vw;
    border-right: 22.8vw solid #62b5d9;
  }
  @media (max-width: 766px) {
    margin: 50px 0;
    .dashboard-left-arrow {
      width: 425px;

    }
    .dashboard-left-arrow-mobile {
      display: none;
      position: absolute;
    right: 0;
    z-index: 0;
    }
  }
  @media (max-width: 555px) {
    .dashboard-left-arrow {
      display: none;
    }
    .dashboard-left-arrow-mobile {
      width: 352px;
      display: block;
    }
  }
`;
const BuyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-area: 2 / 1 / 5 / 3;
  margin-top: min(90px, 6.4vw);
  .dropdown-wrapper {
    border-radius: 0 0;
    width: auto !important;
  }
  .dashboard-right-arrow {
    position: absolute;
    left: 0;
    z-index: 0;
    width: min(783px, 55.5vw);
  }
  .buy-triangle {
    width: 0;
    height: 0;
    border: 0 solid transparent;
    border-top-width: 15.26vw;
    border-bottom-width: 15.26vw;
    border-left: 22.8vw solid #074269;
  }
  .dashboard-right-arrow-mobile {
    display: none;
  }
  @media (max-width: 766px) {
    margin: 50px 0;
    .dashboard-right-arrow {
      width: 425px;
    }
    .buy-triangle {
      display: none;
    }
    .text-wrapper {
      margin: 0;
      width: 100%;
    }
  }
  @media (max-width: 555px) {
    margin: 70px 0;
    .dashboard-right-arrow {
      display: none;
    }
    .dashboard-right-arrow-mobile {
      width: 352px;
      position: absolute;
      left: 0;
      display: block;
    }
  }
`;
const DropdownContainer = styled.div`
  .btn-secondary:not(:disabled):not(.disabled).active,
  .btn-secondary:not(:disabled):not(.disabled):active,
  .show > .btn-secondary.dropdown-toggle {
    background-color: #fff !important;
    border-color: #fff !important;
  }
  .btn-secondary:not(:disabled):not(.disabled).active:focus,
  .btn-secondary:not(:disabled):not(.disabled):active:focus,
  .show > .btn-secondary.dropdown-toggle:focus {
box-shadow: none;
    } 
  .dropdown-toggle {
    background: #fff;
    border-color: #fff;
    width: 40px;
    
    :active {
      background-color: #fff !important;
      border-color: #fff !important;
    }
    .seller-categories-menu {
      .type-ahead-search-input .dropdown-menu .dropdown-item:hover,
      .type-ahead-search-input .dropdown-menu .dropdown-item:active,
      .type-ahead-search-input .dropdown-menu .dropdown-item.active {
        background-color: #62b5d9;
      }
    }
  }
  .dropleft .dropdown-toggle::before {
    position: absolute;    
    left: calc(50% - 4.6px);
    top: calc(50% - 8.6px);
    width: 11px;
    height: 11px;
    border: solid #0a5587;
    border-width: 0px 2px 2px 0;
    transform: rotate(45deg);
  }
`;

const SearchSection = styled.div`
.type-ahead-search-input {
  width: min(341px, 24vw);
  @media (max-width:650px) {
    width: 100%;
  }
}
`;
const BuyerSellerPalletImg = styled.div`
padding: 10px;
  img {
    max-width: 100%;
    display: inline-flex;
  }
  @media (min-width: 651px) {
    img {
      display: none;
    }
  }
`

const LinkSection = styled.div`
position: relative;
z-index:2;
a {
    font-size: min(16px,2vw);
    margin-top: 6px;
    span {
      color: rgb(0, 68, 110);
    }
}

@media (max-width: 767px) {
      a {
        font-size: 16px;
    }
  }
`

const CardExpiryBanner = styled.div`
    position: absolute;
    top: -36px;
    bottom: 0;
    right: 0;
    left: 0;
    background: #ffffff70;
    z-index: 2;
    display: flex;
    align-items: center;
    font-weight: 700;
    text-align: center;
    justify-content: center;
    p {
      border-radius: 7px;
    height: 200px;
    box-shadow: 0 4px 6px 0 rgb(0 0 0 / 16%);
    display: flex;
    align-items: center;
    padding: 30px;
    max-width: 800px;
    justify-content: center;
    backdrop-filter: saturate(180%) blur(20px);
    background-color: rgb(255 255 255 / 46%);
    font-size: 18px;
    span {
      color: #007bff;
      cursor: pointer;
    }
    img {
      position: absolute;
      right:15px;
      top:15px;
      height:25px;
      cursor: pointer;
    }
    }
`

export {
  Container,
  DashBoardWrapper,
  DashBoardHeading,
  BuyPallets,
  SellPallets,
  SellWrapper,
  BuyWrapper,
  DropdownContainer,
  SearchSection,
  BuyerSellerPalletImg,
  LinkSection,
  CardExpiryBanner
};
